// extracted by mini-css-extract-plugin
export default {"logoutButton":"LogoutButton_logoutButton__y8NIl"};